<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
    <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
      <el-col class="flex-box al-c" :span="4">
        <el-button type="primary" @click="initPage">查询</el-button>
        <el-button type="primary" @click="addFn">添加</el-button>
      </el-col>
    </Sift>
    
    <div class="table-con">
      <el-table class="w100 mt20 table" header-row-class-name="table-head" row-class-name="cu-p" stripe :data="list" height="100%">
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="toolName" label="工具名称"></el-table-column>
        <el-table-column align="center" prop="toolTarget" label="工具权限">
          <template slot-scope="scope">
            {{ scope.row.toolTarget | filterToString }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="toolUrl" label="工具地址"></el-table-column>
        <!-- <el-table-column align="center" label="工具用途">
          <template slot-scope="scope">
            {{ scope.row.toolUse | toolUseFn }}
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createUser" label="创建人"></el-table-column>
        <el-table-column align="center" prop="refuseIP" label="操作">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="info" @click="editFn(scope.row.id, scope.row.toolName)">详情</span>
              <span class="delete" @click="deleteFn(scope.row.id, scope.row.toolName)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <!-- 详情、新增 -->
    <ToolDialog ref="toolDialog" :prorData="prorData"/>

  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import ToolDialog from "@/components/management/tool/ToolDialog";

export default {
  name: "Tool",
  components: {
    Sift,
    ToolDialog
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      prorData: null,
      selectObj: {
        data: []
      }
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchSiftData();
    this.getServeObj();
  },
  destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData() {
      this.loading = true;

      setTimeout(() => {
        this.siftData = [
          {
            type: "text",
            key: "title",
            label: "工具名称",
            placeholder: "",
            default: ""
          }
        ];
        this.loading = false;
        this.$nextTick(() => {
          this.initPage();
        });
      }, 500);
    },

    // 获取查询列表
    getListFn () {
      let data = this.$qs.stringify({
        toolName: this.$refs.needSift.getValue().title,  // 获取搜索条件的值
        pageNum: this.pageNum,
        pageSize: this.pageSize
      });

      this.$http.post( "/tool/toolPageList", data )
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.list = data.resData.list;
          this.total = data.resData.total;
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      })
    },

    // 添加
    addFn() {
      this.$refs.toolDialog.dialogShow("", "");
    },

    // 删除
    deleteFn (id, name) {
      this.$confirm( "是否确定删除" + name + " ?", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        // 删除接口
        this.$http.get( "/tool/toolDelete?toolId=" + id )
        .then( ({data}) => {
          if ( data.resCode === 0 ) {
            this.$message.success( name + "删除成功!" );
            this.getListFn();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.$message({ type: "info", message: "已取消删除" });          
      });
    },

    // 详情
    editFn (id, name) {
      this.$refs.toolDialog.dialogShow(id, name);
    },

    // 服务对象
    getServeObj () {
      this.$http.get( "/hallServe/targetList" )
      .then( res => {
        res.data.resData.forEach( e => {
          this.selectObj.data.push({ value: e.id + "", label: e.targetTypeName });
        });
      })
      .catch( () => {
        this.$message.error("网络错误，服务类型接口请求失败！");
      });
    },

    // 默认页面数据
    initPage() {
      this.pageNum = 1;
      this.getListFn();
    },

    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getListFn();
    },
  },
  watch: {
    "selectObj.data": {
      handler (val, oldVal) {
        this.prorData = val;
      },
      immediate: true
    }
  },
  filters: {
    // 数组对象 转字符串 arr后台返回的数组
    filterToString (arr) {
      let backArr = [];

      eval("("+ arr +")").forEach( e => {
        backArr.push(e.targetName);
      });
      return backArr.join("、")
    },
    toolUseFn (val) {
      let nub = val === 0 ? "默认" : val === 1 ? "信息公开" : "个人办公";
      return nub
    }
  }
};
</script>

<style scoped>
  .table-con {
    height: calc(100vh - 270px);
  }
  
  .to-use {
    width: 100%;
  }

  .to-use span {
    padding: 0 8px;
    display: inline-block;
  }

  .to-use .info {
    color: #409EFF;
  }

  .to-use .delete {
    color: #cdcdcd;
  }

  .to-use .info:hover {
    color: #336ab1;
  }

  .to-use .delete:hover {
    color: #606266;
  }
</style>
